export default __webpack_public_path__ + "static/media/maduro-2Open.681a66ad.jpg";